import iAjax from 'iajax'

export default {
	loadData (credentials = {}) {
		return new Promise((resolve, reject) => {
			iAjax.get('/measure-units', credentials, (data) => {
				resolve(data)
			}, () => {
				throw Error('Chyba pri načítaní jednotiek.')
			})
		})
	}
}
